module.exports = {"name":"Facebook Chat","menu_entries":{"chat":"Facebook Chat"}}